// Digit grouping follows the workspace's money, as lib/money already does for
// amounts: Indian grouping (1,67,691) for a rupee workspace, thousands
// (167,691) for every other.
//
// Counts are printed with n.toLocaleString('en-IN') in some 390 places, written
// when every workspace was Indian. A dollar store (Trendia, 19 Oct 2026) read
// "1,67,691 sessions" on Funnels and "3,58,462 of 6,00,000" on Billing. Rather
// than thread a locale through every one of them (and miss the next), the one
// call they share is taught the workspace: 'en-IN' means "this workspace's
// grouping". Any other locale, and a rupee workspace, are untouched, and Dates
// are not affected (only Number.prototype).
import { workspaceCurrency } from './workspace-display';

const MARK = '__workspaceGrouping';

export function groupingLocale(currency = workspaceCurrency()) {
  return String(currency || 'INR').toUpperCase() === 'INR' ? 'en-IN' : 'en-US';
}

export function installNumberLocale(proto = Number.prototype) {
  if (proto.toLocaleString[MARK]) return false;
  const original = proto.toLocaleString;
  const workspaceAware = function toLocaleString(locales, options) {
    return original.call(this, locales === 'en-IN' ? groupingLocale() : locales, options);
  };
  workspaceAware[MARK] = true;
  // eslint-disable-next-line no-extend-native
  proto.toLocaleString = workspaceAware;
  return true;
}
